export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | undefined> {
  if (!('serviceWorker' in navigator)) {
    console.debug('Service workers not supported on this platform/browser');
    return undefined;
  }
  if (!('PushManager' in window)) {
    console.debug('Push API not supported on this platform/browser');
    return undefined;
  }
  if (!('Notification' in window)) {
    console.debug('Notifications API not supported on this platform/browser');
    return undefined;
  }

  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        return registration.pushManager.getSubscription();
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  } else {
    console.warn('Push notifications not supported in this browser');
  }

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });

    registration.onupdatefound = () => {
      const installingWorker = registration.installing;
      if (installingWorker) {
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.debug('New service worker available; refresh to update');
            } else {
              console.debug('Service worker installed for the first time');
            }
          }
        };
      }
    };

    return registration;
  } catch (error) {
    console.error('Service Worker registration failed:', error);
    throw error;
  }
}